import React from "react";
import { FaStar } from "react-icons/fa";
import t4 from "../assets/t4.png";
import t6 from "../assets/t6.jpeg";
import t5 from "../assets/t5.jpg";

const Testimonials = () => {
  const testimonials = [
    {
      name: "Saurabh Sinha",
      comment:
        "SurveysIQ has provided a reliable and consistent source of monthly income. Earning ₹20,000 per month through their platform has been both efficient and rewarding, making it a valuable part of my routine.",
      rating: 5,
      image: t4,
    },
    {
      name: "Abhishek Kumar",
      comment:
        "I highly appreciate SurveysIQ for its user-friendly interface and seamless experience. It's one of the most effective and trustworthy platforms for earning money online.",
      rating: 5,
      image: t6,
    },
    {
      name: "Soni Roy",
      comment:
        "SurveysIQ stands out for its transparency and timely payouts. It's a dependable platform for anyone looking to earn a steady side income online.",
      rating: 5,
      image: t5,
    },
  ];

  return (
    <section className="py-8 bg-gray-50">
      <div className="max-w-9vw mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="sm:text-5xl text-[40px] leading-[61px] break-words font-bold text-left font-sans text-gray-800 mb-12">
          Testimonials
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <img
                src={testimonial.image}
                className="h-80 w-full object-cover rounded-md pl-3"
                alt={testimonial.name}
              />

              <div className="flex gap-4 mt-4 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <FaStar key={i} className="text-yellow-400 w-5 h-5" />
                ))}
              </div>

              <p className="font-semibold text-3xl font-sans text-black">
                {testimonial.name}
              </p>
              <p className="text-black text-xl font-sans  mb-4 mt-4">
                "{testimonial.comment}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
